export function isOfferPageFullyPaidWithPoints(
  pointsToApply?: number,
  priceInPoints?: number,
  pointsHideZeroCash?: boolean,
): boolean {
  if (!pointsToApply || pointsToApply <= 0 || pointsHideZeroCash || !priceInPoints || priceInPoints <= 0) {
    return false
  }

  return pointsToApply >= priceInPoints
}
